export default __webpack_public_path__ + "static/media/Untitled-3.9b183101.jpg";